import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

export const Text = styled(Typography)`
  line-height: 1.25;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    margin-bottom: ${theme.spacing(2)};
    margin-top: ${theme.spacing(1.5)};
    color: ${theme.colors.secondaryGrey};
  `}
`;
